import { Drawer } from '@mantine/core';
export const _GridDrawer = (props) => {
    return (<Drawer.Root target={`#__next`} opened={props.drawer.opened} onClose={props.drawer.onClose}>
      <Drawer.Overlay />
      <Drawer.Content>{props.children}</Drawer.Content>
    </Drawer.Root>);
};
